import { useInterval } from '@hooks/utils/useInterval';
import { alreadyEnteredInterviewer } from '@stores/selectors/alreadyEnteredLog';
import { useAtomValue } from 'jotai';
import { useState } from 'react';
import { CircleLoading, Container, Content, Count, Title } from './style';

const CountDown = ({
  title,
  startCount = 10,
}: {
  title?: string;
  startCount?: number;
}) => {
  const alreadyEntered = useAtomValue(alreadyEnteredInterviewer);
  const [count, setCount] = useState(startCount);

  useInterval(async () => {
    if (!alreadyEntered && count > 0) {
      setCount(count - 1);
    }
  }, 1000);

  if (alreadyEntered || count <= 0) return null;

  return (
    <Container>
      <CircleLoading />
      <Content>
        <Title>{title}</Title>
        <Count>{count}</Count>
      </Content>
    </Container>
  );
};

export default CountDown;
